import React, { useState } from 'react'
import SentimentSatisfiedOutlinedIcon from '@material-ui/icons/SentimentSatisfiedOutlined';
import Picker from 'emoji-picker-react';
import AudioReactRecorder, { RecordState } from 'audio-react-recorder'
import AttachFileIcon from '@material-ui/icons/AttachFile';
import MicIcon from '@material-ui/icons/Mic';
import SendIcon from '@material-ui/icons/Send';
import DeleteIcon from '@material-ui/icons/Delete';
import PauseCircleOutlineIcon from '@material-ui/icons/PauseCircleOutline';
import StopIcon from '@material-ui/icons/Stop';
import firebase, { storage, db } from '../../../Firebase/firebase'
import AllInclusiveIcon from '@material-ui/icons/AllInclusive';
import { v4 as uuid } from 'uuid';

const ChatFooter = ({ 
  chatId,
  chatDetails,
  senderName,
  sendMessage, 
  handleSendMessageOnEnter, 
  textMessage, 
  setTextMessage,
  showEmojiPicker, 
  setShowEmojiPicker
}) => {
  const [recordState, setRecordState] = useState(null);
  const [isRecording, setIsRecording] = useState(false)
  const [showVoiceRecording, setShowVoiceRecording] = useState(false);
  const [voiceNote, setVoiceNote] = useState(null);
  const [previewVoiceNote, setPreviewVoiceNote] = useState(false);
  // const [voiceNoteUrl, setVoiceNoteUrl] = useState('');
  const [showProgress, setShowProgress] = useState({visible: false, width: 0});
  const [hideRecording, setHideRecording] = useState(false);
  const [proceedSending, setProceedSending] = useState(false);
  const [deleteRecordedNote, setDeleteRecordedNote] = useState(false)

  // Voice note functionality

  const startRecording = () => {
    setDeleteRecordedNote(false)
    setHideRecording(false)
    setRecordState(RecordState.START)
    setVoiceNote(null)
    setIsRecording(true)
  }

  const pauseRecording = () => {
    setRecordState(RecordState.PAUSE);
    setIsRecording(false);
  }

  const deleteRecording = () => {
    setDeleteRecordedNote(true)
    setVoiceNote(null)
    setIsRecording(false)
    setPreviewVoiceNote(false)
    setRecordState(RecordState.STOP)
    setTimeout(()=>{
      setRecordState(RecordState.NONE)
      setShowVoiceRecording(false)
    }, 1)
  }

  const stopRecording = () => {
    setProceedSending(false)
    setRecordState(RecordState.STOP)
    setPreviewVoiceNote(true)
    // setShowVoiceRecording(false)
    setIsRecording(false)
  }

  const onRecordingStop = (audioData) => {
    if(deleteRecordedNote){
      setDeleteRecordedNote(false)
      return
    }
    // if(previewVoiceNote){
      setVoiceNote(audioData)
    // }
    if(proceedSending){
      setPreviewVoiceNote(false);
      setHideRecording(true)
      setProceedSending(false)
  
      let storageRef = storage.ref();
      let voiceNoteRef = `voice-notes/chats/${chatId}/name=${senderName}/${uuid()}`
      let uploadTask = storageRef.child(voiceNoteRef).put(audioData.blob);
  
      uploadTask.on('state_changed', 
        (snapshot) => {
          // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
          var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          setPreviewVoiceNote(false);
          if(progress > 0 && progress < 100){
            setShowProgress({visible: true, width: progress})
          }else{
            setShowProgress({visible: false, width: progress})
            // setPreviewVoiceNote(true)
          }
        }, 
        (error) => {
         
        }, 
        () => {
          uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
            setVoiceNote(null)
            setIsRecording(false)
            setRecordState(RecordState.STOP)
            setShowProgress({visible: false, width: 0})
            setShowVoiceRecording(false)
            
            db.collection('groups').doc(chatId).set({
              ...chatDetails,
              lastPerson: senderName,
              lastMessage: 'Voice Note...'
            })
        
            db.collection('groups').doc(chatId).collection('messages').add({
              name: senderName,
              time: new Date().getTime(),
              message: '',
              type: 'voice-note',
              voiceNoteUrl: downloadURL
            }).then(()=> {
              setTimeout(()=>{
                setRecordState(RecordState.NONE)
              }, 10)
              })
          });
        }
      );
    }
    console.log(audioData)
  }

  const sendVoiceNote = () => {
    if(voiceNote){
      setPreviewVoiceNote(false);
      setHideRecording(true)
  
      let storageRef = storage.ref();
      let voiceNoteRef = `voice-notes/chats/${chatId}/-name=${senderName}`
      let uploadTask = storageRef.child(voiceNoteRef).put(voiceNote.blob);
  
      uploadTask.on('state_changed', 
        (snapshot) => {
          // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
          var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          setPreviewVoiceNote(false);
          if(progress > 0 && progress < 100){
            setShowProgress({visible: true, width: progress})
          }else{
            setShowProgress({visible: false, width: progress})
            // setPreviewVoiceNote(true)
          }
        }, 
        (error) => {
         
        }, 
        () => {
          uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
            setVoiceNote(null)
            setIsRecording(false)
            setRecordState(RecordState.STOP)
            setShowProgress({visible: false, width: 0})
            setShowVoiceRecording(false)
            setProceedSending(false)
            
            db.collection('groups').doc(chatId).set({
              ...chatDetails,
              lastPerson: senderName,
              lastMessage: 'Voice Note...'
            })
        
            db.collection('groups').doc(chatId).collection('messages').add({
              name: senderName,
              time: new Date().getTime(),
              message: '',
              type: 'voice-note',
              voiceNoteUrl: downloadURL
            }).then(()=> {
              setTimeout(()=>{
                setRecordState(RecordState.NONE)
              }, 10)
              })
          });
        }
      );
    }else{
      stopRecording()
      setRecordState(RecordState.STOP)
      setIsRecording(false);
      setProceedSending(true)
    }
  }


  const onEmojiClick = (event, emojiObject) => {
    setTextMessage(`${textMessage}${emojiObject.emoji}`)
  };

  // const sendVoiceNote = (file) => {
    
  // }

  if(showVoiceRecording){
    return (
      <div className="chat__footer">
        <div className="chat__footer__container" style={{justifyContent: 'flex-end'}}>
          {!hideRecording && <DeleteIcon onClick={deleteRecording} style={{color: '#667781', fontSize: '1.8em', margin: '0 0.3em'}} />}
          <div 
            style={{
              width: previewVoiceNote ? '310px' : '282px', 
              border: !hideRecording && '1px solid lightgray', 
              borderRadius: '62px', 
              height: '42px', 
              overflow: "hidden", 
              display: 'grid',
              placeContent: 'center',
              marginRight: previewVoiceNote && '1em'
            }}
          >
            {(!hideRecording && !voiceNote) && <AudioReactRecorder 
              state={recordState} 
              onStop={onRecordingStop}
              backgroundColor="#F0F2F5"
              foregroundColor="#2AA884"
              canvasWidth="276px"
              canvasHeight="13px"
            />}
            {(!hideRecording && previewVoiceNote && voiceNote) && 
              (<audio controls>
                <source src={voiceNote.url} type={voiceNote.type} />
                Your browser does not support the audio tag.
               </audio>
              )
            }
            {
              showProgress.visible && 
              <div style={{width: '282px', height: '20px', border: '1px solid lightgrey', marginRight: '5em'}}>
                <div style={{width: `${showProgress.width}%`, background: '#2AA884', height: '100%'}}></div>
              </div>
            }
          </div>
          {(!previewVoiceNote && !hideRecording) && <StopIcon style={{color: '#F93B31', fontSize: '1.9em', margin: '0 0.5em'}} onClick={stopRecording} />}
          {(!isRecording && !previewVoiceNote && !hideRecording) && <MicIcon style={{color: '#F93B31', fontSize: '1.9em', margin: '0 0.5em'}} onClick={startRecording} />}
          {(!hideRecording && isRecording) && <PauseCircleOutlineIcon style={{color: '#F93B31', fontSize: '1.9em', margin: '0 0.5em'}} onClick={pauseRecording} />}
          <span 
            style={{
              display: 'grid', 
              placeContent: 'center',
              background: '#2AA884',
              width: '36px',
              height: '36px',
              borderRadius: '50%'
            }}
            onClick={sendVoiceNote}
          >
            {!hideRecording && <SendIcon style={{color: '#fff', fontSize: '1.2em'}} />}
            {hideRecording && <AllInclusiveIcon style={{color: '#fff', fontSize: '1.2em'}} />}
          </span>
        </div>
      </div>
    )
  }

  return (
    <div className="chat__footer">
      <div className="chat__footer__container">
        <div className="emoji">
          <span>
            <SentimentSatisfiedOutlinedIcon
              style={{color: showEmojiPicker && '#1d8069'}}
              onClick={()=> setShowEmojiPicker(!showEmojiPicker)}
            />
            {showEmojiPicker && 
            <Picker 
              preload={true} 
              onEmojiClick={onEmojiClick}
              pickerStyle={{
                width: '200px !important', 
                position: 'absolute', 
                bottom: '65px',
                boxShadow: 'none',
                border: '1px solid lightgray'
              }} 
            />}
          </span>
          <span>
            <AttachFileIcon />
          </span>
        </div>
        <div className="input__box">
          <input type="text" placeholder='Type a message' value={textMessage} onKeyDown={handleSendMessageOnEnter} onChange={(e)=> setTextMessage(e.target.value)} />
        </div>
        {!textMessage && <span>
          <MicIcon onClick={()=> {setShowVoiceRecording(true); setTimeout(()=> {startRecording()}, 500)}} />
        </span>}
        {textMessage && <span>
          <SendIcon onClick={sendMessage} />
        </span>}
      </div>
    </div>
  )
}

export default ChatFooter